import React, { useState, useEffect } from "react";
import { Plus, Check, Trash2 } from "lucide-react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";

export default function DepthAlertSplash({
  open,
  onOpenChange,
  onSubmit,
  initial,
  onDelete,
  currentDepth,
}) {
  const editing = Boolean(initial);
  const [depth, setDepth] = useState("");
  const [description, setDescription] = useState("");

  useEffect(() => {
    if (!open) return;
    if (initial) {
      setDepth(initial.depth != null ? String(initial.depth) : "");
      setDescription(initial.description || "");
    } else {
      setDepth(currentDepth != null ? String(currentDepth) : "");
      setDescription("");
    }
  }, [open, initial, currentDepth]);

  const handleSubmit = (e) => {
    e.preventDefault();
    const d = Number(depth);
    if (depth === "" || isNaN(d)) return;
    onSubmit({ depth: d, description: description.trim() });
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md rounded-2xl">
        <DialogHeader>
          <DialogTitle>{editing ? "Edit prediction" : "New prediction"}</DialogTitle>
          <DialogDescription>
            Set a target depth and a note. You'll be notified when drilling gets close.
          </DialogDescription>
        </DialogHeader>
        <form onSubmit={handleSubmit} className="space-y-4 pt-1">
          <div>
            <Label>Depth (m)</Label>
            <Input
              type="number"
              step="any"
              min="0"
              value={depth}
              onChange={(e) => setDepth(e.target.value)}
              placeholder="e.g. 120"
              className="rounded-xl"
              autoFocus
            />
          </div>
          <div>
            <Label>Description</Label>
            <Textarea
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              placeholder="e.g. Reduce feed rate — fault zone expected"
              className="rounded-xl min-h-[96px]"
            />
          </div>
          <div className="flex items-center justify-between gap-2 pt-1">
            {editing && onDelete ? (
              <Button
                type="button"
                variant="destructive"
                className="rounded-xl gap-2"
                onClick={() => onDelete()}
              >
                <Trash2 className="w-4 h-4" /> Delete
              </Button>
            ) : (
              <span />
            )}
            <div className="flex gap-2">
              <Button
                type="button"
                variant="outline"
                onClick={() => onOpenChange(false)}
                className="rounded-xl"
              >
                Cancel
              </Button>
              <Button
                type="submit"
                className="rounded-xl bg-slate-900 hover:bg-slate-800 gap-2"
              >
                {editing ? (
                  <>
                    <Check className="w-4 h-4" /> Save
                  </>
                ) : (
                  <>
                    <Plus className="w-4 h-4" /> Add
                  </>
                )}
              </Button>
            </div>
          </div>
        </form>
      </DialogContent>
    </Dialog>
  );
}